const DashboardTypes = Object.freeze({
  DASHBOARD: 'dashboard',
  AGENDA: 'agenda',
  PLANNING: 'planning',
  SUPPLIER_ORDER: 'supplier_order',
  ANALYTICS: 'analytics',
  STATISTICS: 'statistics',
  INVOICE: 'invoice',
  PURCHASE_ORDER: 'purchase_order',
  QUOTE: 'quote',
  CREDIT_NOTE: 'credit_note',
  PAYMENT: 'payment',
  INVOICE_PROFORMA: 'invoice_proforma',
  TASK: 'task',
  INVOICE_ITEM_THIRD_PARTY_COST: 'invoice_item_third_party_cost'
})

export default DashboardTypes
